import React from "react";
import { Button } from "react-bootstrap";
import "../../../assets/styles/scheduledChanges.scss";

const ScheduleChangeUpdateButton = ({
  onReset,
  onSave,
  disabled = false,
  isSaving = false,
}) => {
  return (
    <div className="sc-buttons sc-detail-buttons sc-update-buttons">
      <Button
        type="button"
        variant="outline-secondary"
        className="sc-btn"
        onClick={onReset}
        disabled={disabled || isSaving}
      >
        Reset
      </Button>

      <Button
        type="button"
        variant="danger"
        className="sc-btn"
        onClick={onSave}
        disabled={disabled || isSaving}
      >
        {isSaving ? "Zapisywanie..." : "Zapisz"}
      </Button>
    </div>
  );
};

export default ScheduleChangeUpdateButton;